<template>
    <div>
        <h3>解决方案</h3>
        <el-form :model="solutionInfo" :rules="rules" ref="solutionInfo" class="demo-form-inline" size="mini" label-width="180px">
            <el-form-item label="解决方案id" prop="solution">{{id}}</el-form-item>
            <el-form-item label="解决方案名称" prop="solutionName">
                <el-input v-model="solutionInfo.solutionName"></el-input>
            </el-form-item>
            <el-form-item label="关联职位" prop="relevanceJob">
                <el-row>
                    <el-col :span="12">
                        <el-input v-model="solutionInfo.relevanceJob"></el-input>
                    </el-col>
                    <el-col :span="8" :offset="1">
                        <el-button type="text" @click="getJob">生成</el-button>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="职位名称" prop="jobName">
                <a :href="`${frontUrl}/job/detail/${solutionInfo.relevanceJob}`" target="_blank">{{solutionInfo.jobName}}</a>
                <el-input type="hidden" v-model="solutionInfo.jobName"></el-input>
            </el-form-item>
            <el-form-item label="传统月薪" prop="traditionSalary">
                <el-input v-model="solutionInfo.traditionSalary"></el-input>
            </el-form-item>
            <el-form-item label="案例介绍" prop="introduce">
                <el-input type="textarea" rows="5" v-model="solutionInfo.introduce"></el-input>
            </el-form-item>
            <el-form-item label="关联类目" prop="categories">
                {{solutionInfo.categories.length ? solutionInfo.categories[0].name : ''}}
                <!-- <el-select v-model="solutionInfo.categories" :multiple="true" value-key="id" placeholder="请选择">
                    <el-option v-for="item in cates" :key="item.id" :label="item.name" :value="item">
                    </el-option>
                </el-select> -->
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="submit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../api'
const {
    solution,
    job,
    cate
} = api
export default {
    name: "solution",
    data() {
        return {
            solutionInfo: {
                solutionName: '',
                relevanceJob: '',
                jobName: '',
                traditionSalary: '',
                introduce: '',
                categories: []
            },
            jobInfo: {},
            cates: [],
            rules: {
                solutionName: [{
                    required: true,
                    message: '请输入职位标题',
                    trigger: 'blur'
                }, {
                    max: 15,
                    message: '长度不能超过 15 个字符',
                    trigger: 'change'
                }],
                relevanceJob: [{
                    required: true,
                    message: '请输入职位id',
                    trigger: 'blur'
                }],
                jobName: [{
                    required: true,
                    message: '职位名称不能为空',
                    trigger: 'change'
                }],
                traditionSalary: [{
                    required: true,
                    message: '请输入传统月薪',
                    trigger: 'blur'
                }],
                introduce: [{
                    required: true,
                    message: '请输入案例介绍',
                    trigger: 'blur'
                }, {
                    max: 60,
                    message: '长度不能超过 60 个字符',
                    trigger: 'change'
                }],
                categories: [{
                    required: true,
                    message: '请选择关联类目',
                    trigger: 'blur'
                }]
            }
        };
    },
    computed: {
        id() {
            return this.$route.params.id;
        },
    },
    watch: {},
    mounted() {
        // this.getCates()
        if (this.id) {
            this.getDetail()
        }
    },
    methods: {
        async getDetail() {
            let {
                data: {
                    code,
                    data
                }
            } = await api.solution.list({
                solutionId: this.id
            })
            if (code == 200) {
                this.solutionInfo = data[0]
            }
        },
        async getJob() {
            if (!this.solutionInfo.relevanceJob) {
                this.$message.error('请填写关联职位id')
                return false
            }
            let {
                data: {
                    code,
                    data
                }
            } = await api.job.detail({
                jobId: this.solutionInfo.relevanceJob
            })
            if (code == 200) {
                if (data.chargingWay === 1) {
                    this.$message.error('配置的职位只能是时薪制！')
                    return false;
                }
                this.jobInfo = data
                this.solutionInfo.jobName = data.title
                this.solutionInfo.categories = data.skillTags
            } else {
                this.solutionInfo.jobName = '';
            }
        },
        async getCates() {
            let {
                data: {
                    code,
                    data
                }
            } = await cate.list();
            if (code == 200) {
                this.cates = data;
            } else {
                this.$message.error('获取职业列表失败，请刷新重试！')
            }
        },
        submit() {
            this.$refs.solutionInfo.validate(valid => {
                if (valid) {
                    this.save();
                } else {
                    return false;
                }
            })
        },
        async save() {
            let action = 'create'
            let {
                solutionName,
                relevanceJob,
                jobName,
                traditionSalary,
                introduce,
                categories
            } = this.solutionInfo
            let obj = {
                solutionName,
                relevanceJob,
                jobName,
                traditionSalary,
                introduce,
                categories
            }
            if (this.id) {
                obj.solutionId = this.id
                action = 'update'
            }
            let {
                data: {
                    code
                }
            } = await api.solution[action](obj)
            if (code == 200) {
                this.$message.success('保存成功！')
                this.$router.push('/solutions')
            }
        },
    },
};
</script>
<style scoped>
.demo-form-inline {
    width: 640px;
}
</style>


// WEBPACK FOOTER //
// src/views/solution/solution.vue